module.exports = __webpack_public_path__ + "35139ae2b6e35003f03d79e936ed1d00.png";